module.exports = __webpack_public_path__ + "img/style14bg.b39041a8.png";